'use client'
import type { MobileHeaderBarProps } from '@maestro/commerce-blocks/components/mobile-header-bar/mobile-header-bar.types'

import classNames from 'classnames'
import { useTranslations } from 'next-intl'
import React, { useRef } from 'react'

import { useIsScrolled } from '@maestro/commerce-blocks/hooks/use-is-scrolled'
import { Button } from '@pearlconvert/ui/components/button'

import '@maestro/commerce-blocks/components/mobile-header-bar/styles/mobile-header-bar.scss'

export default function MobileHeaderBar({
  backButtonTitle,
  closeButtonTitle,
  closeButtonUrl = '/',
  handleBack = () => {},
  isSticky = true,
  isVisibleBackButton = false,
  isVisibleCloseButton = true,
  title,
}: MobileHeaderBarProps) {
  const mobileHeaderBarRef = useRef<HTMLDivElement>(null)
  const isScrolled = useIsScrolled()
  const t = useTranslations('commerce-blocks')

  return (
    <header
      ref={mobileHeaderBarRef}
      className={classNames(
        'slidein__header mobile-header-bar mobile-only no-mobile-header',
        {
          'slidein__header--sticky': isSticky,
          'slidein__header--scrolled': isScrolled,
        }
      )}
    >
      {isVisibleBackButton && (
        <div className="slidein__back mobile-header-bar__back">
          <Button
            className="slidein__back-button mobile-header-bar__back-button"
            type="empty"
            buttonType="button"
            iconLeft="arrow-left"
            title={backButtonTitle || t('mobile-header-bar.back')}
            size="fixed"
            onClick={handleBack}
          />
        </div>
      )}
      <h1 className="slidein__title mobile-header-bar__title">{title}</h1>
      {isVisibleCloseButton && (
        <div className="slidein__close mobile-header-bar__close">
          <Button
            className="slidein__close-button mobile-header-bar__close-button"
            type="empty"
            iconLeft="close"
            title={
              closeButtonTitle ||
              t('mobile-header-bar.close', { title: title || '' })
            }
            size="fixed"
            url={closeButtonUrl}
          />
        </div>
      )}
    </header>
  )
}
